import React from 'react';
import { StyledEngineProvider, ThemeProvider } from '@mui/material/styles';
import { ThemeProvider as StyledThemeProvider } from 'styled-components';
import { getTheme } from '@cw-ui/asio-neon-themes';

export const appTheme = getTheme('light');

const AppThemeProvider = ({ children }) => (
  <StyledEngineProvider injectFirst>
    <ThemeProvider theme={appTheme}>
      <StyledThemeProvider theme={appTheme}>{children}</StyledThemeProvider>
    </ThemeProvider>
  </StyledEngineProvider>
);

export const withAppTheme = (children, key) => (
  <AppThemeProvider key={key}>{children}</AppThemeProvider>
);

export default AppThemeProvider;